import { useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router";

import { useMsal } from "@azure/msal-react";

import { authActions } from "../../store/authReducer";
import { uiActions } from "../../store/uiReducer";
import LoadingFallback from "../LoadingFallback";

export default function Logout() {
  const { instance, accounts } = useMsal();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Check if this is a forced logout (401) vs explicit user logout
  const isForcedLogout = location.state?.forced === true;

  const processLogout = useCallback(async () => {
    // Set the logout flag FIRST to prevent auto-login
    sessionStorage.setItem("hub-app-logged-out", "true");
    sessionStorage.removeItem("hub-app-processing-login");
    
    // Clear initURL only for explicit logout - preserve it for 401-forced logout
    // so user can return to their page after re-authenticating
    if (!isForcedLogout) {
      sessionStorage.removeItem("initURL");
    }

    dispatch(authActions.logout());

    // Remove the account from MSAL cache (local logout only)
    if (accounts.length > 0) {
      instance.setActiveAccount(null);

      // Clear tokens from cache without logging out of MS account
      try {
        await instance.clearCache();
      } catch (err) {
        console.error("Error clearing MSAL cache:", err);
        dispatch(uiActions.setErrors(err));
      }
    }

    // Navigate to login
    navigate(`${process.env.PUBLIC_URL}/public/login`, { replace: true });
  }, [accounts.length, dispatch, instance, isForcedLogout, navigate]);

  useEffect(() => {
    processLogout();
  }, [processLogout]);

  return <LoadingFallback message="Logging out..." />;
}
